import { getWrapperClassName } from '@/components/design-system/utils'
import React from 'react'

type Size = 'sm' | 'base' | 'lg' | 'xl' | '2xl'
type Props = Readonly<{
  className?: string
  size: Size
}>

export const TLSpinner = (props: Props) => {
  const size = getSize(props.size)
  return (
      <div className={ getWrapperClassName(props.className, 'flex gap-1') }>
        <p className={ `text-gray-300 transition cursor-default animate-[spinnerpulse_1.3s_cubic-bezier(0.4,_0,_0.6,_1)_infinite] ${ size } font-spacegrotesk font-bold` }>o</p>
        <p className={ `text-gray-300 transition cursor-default animate-[spinnerpulse_1.3s_cubic-bezier(0.4,_0,_0.6,_1)_0.4s_infinite] ${ size } font-spacegrotesk font-bold` }>o</p>
        <p className={ `text-gray-300 transition cursor-default animate-[spinnerpulse_1.3s_cubic-bezier(0.4,_0,_0.6,_1)_0.8s_infinite] ${ size } font-spacegrotesk font-bold` }>o</p>
      </div>
  )

  function getSize(spinnerSize: Size): string {
    switch (spinnerSize) {
      case '2xl':
        return 'text-8xl'
      case 'xl':
        return 'text-6xl'
      case 'lg':
        return 'text-4xl'
      case 'sm':
        return 'text-sm'
      default:
        return 'text-2xl'
    }
  }
}

TLSpinner.defaultProps = {
  className: '',
  size: 'base'
}
